/**
 * Дата для поля выбора даты (`<input type="date">`).
 *
 * ⚠️ СЕРВЕР ОТДАЁТ ПОЛНОЕ ВРЕМЯ («2026-09-10T00:00:00Z»), а поле понимает
 * только «2026-09-10» и на всё остальное показывает ПУСТО. Живая проверка
 * 04.09.2026: при правке правила расписания обе даты выглядели незаполненными,
 * и куратор, нажав «Сохранить», стёр бы окно, которое сам же задал. В списке
 * дел та же беда была и раньше.
 */
export function dayValue(raw?: string | null): string {
  return raw ? raw.slice(0, 10) : '';
}
